import React, { Suspense, useCallback } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider } from '@contexts/AppContext';

import RenderTiptapContent from './Blocks/RenderTiptapContent';
import SectionBlock from './Blocks/SectionBlock';
import TextBlock from './Blocks/TextBlock';
import { BlockTypes } from './Blocks/constants';
import type { PageTemplateJSON, PageTemplateProps, RecursiveValue } from './interfaces';
import './styles.scss';

const queryClient = new QueryClient();

const PageTemplates = ({ templateJSON, ...props }: PageTemplateProps) => {
  const RenderedTemplate = useCallback((blocks: PageTemplateJSON[]) => {
    if (blocks.length === 0) return;

    return blocks?.map((block) => {
      const contentBlock = block.content?.json ? block.content.json : block?.children;
      const config = block?.config;
      const type = block.type;

      if (!contentBlock) return;

      switch (type) {
        case BlockTypes.Image:
          return <div key={block.id}>IMAGE MODULE</div>;
        case 'section':
          return (
            <SectionBlock key={block.id} config={config}>
              {RenderedTemplate(contentBlock as PageTemplateJSON[])}
            </SectionBlock>
          );
        case BlockTypes.TextContainer:
          return (
            <TextBlock key={block.id} config={config}>
              <RenderTiptapContent
                config={config}
                contentBlock={contentBlock as Record<string, RecursiveValue>}
              />
            </TextBlock>
          );
        default:
          return (
            <React.Fragment key={block.id}>
              <RenderTiptapContent
                config={config}
                contentBlock={contentBlock as Record<string, RecursiveValue>}
              />
            </React.Fragment>
          );
      }
    });
  }, []);

  return (
    <AppContextProvider {...props}>
      <QueryClientProvider client={queryClient}>
        <Suspense fallback={<div>Loading…</div>}>
          <main className="px-0 sm:px-28">
            <div className="m-auto max-w-container-lg">{RenderedTemplate(templateJSON.blocks)}</div>
          </main>
        </Suspense>
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default PageTemplates;
